import { doRequest } from '../../Request';

export const checkMaintenanceMode = () => {
  return doRequest({
    url: `/maintenance_mode?timestamp=${Date.now()}`,
    withAuth: false,
  });
};
